module.exports = __webpack_public_path__ + "static/media/general.3a287892.md";